import { getTexte } from '@/api/relances/index';
import genererGuid from '@/services/general/genererGuid';

export default async function genererRelance(mouvementClients, dateRelance, numRelance) {
  const mvtIds = mouvementClients.map(mvt => mvt.id);
  const relance = {
    texte: '',
    numRelance: numRelance > 3 ? 3 : numRelance,
    dateRelance: dateRelance,
    payeurId: mouvementClients[0].payeurId,
    payeur: {
      id: mouvementClients[0].payeurId,
      nomCommercial: mouvementClients[0].payeurNomCommercial,
      nomJuridique: mouvementClients[0].payeurNomJuridique,
      adresse: mouvementClients[0].payeurAdresse,
      blocageLevel: mouvementClients[0].payeurBlocageLevel,
      dateBlocageLevel: mouvementClients[0].payeurDateBlocageLevel,
    },
    regleFacturationId: mouvementClients[0].regleFacturationId,
    mouvementsClientIds: mvtIds,
    mouvementsClients: [],
    id: genererGuid(),
    isCreate: true,
    actif: true,
    commentaire: '',
  };
  if (mvtIds.length) {
    const params = {
      mouvementClientIds: mvtIds,
      referenceTexte: numRelance > 3 ? 3 : numRelance,
    };
    relance.texte = (await getTexte(params)).data.result;
  }
  return relance;
}
